import React from 'react';

const PosQr: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.67896 4.50445C7.94106 2.16803 9.94616 0.666656 12.1592 0.666656H27.8402C30.0532 0.666656 32.0582 2.16798 32.3204 4.50438C32.5046 6.14709 32.6663 8.49266 32.6663 11.6667C32.6663 16.869 32.2303 28.5067 31.9892 34.5471C31.8822 37.2269 29.6773 39.3333 27.0003 39.3333H12.999C10.322 39.3333 8.11712 37.2269 8.01015 34.547C7.76904 28.5067 7.33301 16.869 7.33301 11.6667C7.33301 8.4927 7.49469 6.14715 7.67896 4.50445ZM12.1592 2.66666C10.8234 2.66666 9.80002 3.53715 9.6665 4.72741C9.49126 6.28956 9.33301 8.56033 9.33301 11.6667C9.33301 16.8197 9.7668 28.4106 10.0086 34.4673C10.0725 36.0695 11.3906 37.3333 12.999 37.3333H27.0003C28.6087 37.3333 29.9268 36.0695 29.9907 34.4673C30.2325 28.4106 30.6663 16.8197 30.6663 11.6667C30.6663 8.56029 30.5081 6.2895 30.3328 4.72735C30.1993 3.53712 29.1759 2.66666 27.8402 2.66666H12.1592Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6665 7.66666C10.6665 6.56208 11.5619 5.66666 12.6665 5.66666H27.3332C28.4377 5.66666 29.3332 6.56209 29.3332 7.66666V22.3333C29.3332 23.4379 28.4377 24.3333 27.3332 24.3333H12.6665C11.5619 24.3333 10.6665 23.4379 10.6665 22.3333V7.66666ZM27.3332 7.66666L12.6665 7.66666V22.3333H27.3332L27.3332 7.66666Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9998 13V9.00003H20.9998V13H18.9998Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9998 18V14H23.9998V18H21.9998Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9998 21L21.9998 21L21.9998 19L25.9998 19L25.9998 21Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9998 21V16H20.9998V21H18.9998Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9998 16H16.9998V14H20.9998V16Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9998 16L21.9998 16L21.9998 14L25.9998 14L25.9998 16Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9998 16H13.9998V14H15.9998V16Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4998 11.5H16.4998V10.5H15.4998V11.5ZM17.9998 13V9.00003H13.9998V13H17.9998Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4998 19.5H16.4998V18.5H15.4998V19.5ZM17.9998 21V17H13.9998V21H17.9998Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4998 11.5H24.4998V10.5H23.4998V11.5ZM25.9998 13V9.00003H21.9998V13H25.9998Z"
      />
      <path d="M31.6665 7.5C32.587 7.5 33.3332 8.24619 33.3332 9.16666V33.3333C33.3332 34.2538 32.587 35 31.6665 35V7.5Z" />
      <path d="M12.083 26.3333C12.083 26.0572 12.3069 25.8333 12.583 25.8333H14.9163C15.1925 25.8333 15.4163 26.0572 15.4163 26.3333V27C15.4163 27.2762 15.1925 27.5 14.9163 27.5H12.583C12.3069 27.5 12.083 27.2762 12.083 27V26.3333Z" />
      <path d="M12.083 28.8333C12.083 28.5572 12.3069 28.3333 12.583 28.3333H14.9163C15.1925 28.3333 15.4163 28.5572 15.4163 28.8333V29.5C15.4163 29.7762 15.1925 30 14.9163 30H12.583C12.3069 30 12.083 29.7762 12.083 29.5V28.8333Z" />
      <path d="M12.083 31.3333C12.083 31.0572 12.3069 30.8333 12.583 30.8333H14.9163C15.1925 30.8333 15.4163 31.0572 15.4163 31.3333V32C15.4163 32.2762 15.1925 32.5 14.9163 32.5H12.583C12.3069 32.5 12.083 32.2762 12.083 32V31.3333Z" />
      <path d="M12.083 33.8333C12.083 33.5572 12.3069 33.3333 12.583 33.3333H14.9163C15.1925 33.3333 15.4163 33.5572 15.4163 33.8333V34.5C15.4163 34.7762 15.1925 35 14.9163 35H12.583C12.3069 35 12.083 34.7762 12.083 34.5V33.8333Z" />
      <path d="M16.2498 26.3333C16.2498 26.0572 16.4736 25.8333 16.7498 25.8333H19.0831C19.3592 25.8333 19.5831 26.0572 19.5831 26.3333V27C19.5831 27.2762 19.3592 27.5 19.0831 27.5H16.7498C16.4736 27.5 16.2498 27.2762 16.2498 27V26.3333Z" />
      <path d="M16.2498 28.8333C16.2498 28.5572 16.4736 28.3333 16.7498 28.3333H19.0831C19.3592 28.3333 19.5831 28.5572 19.5831 28.8333V29.5C19.5831 29.7762 19.3592 30 19.0831 30H16.7498C16.4736 30 16.2498 29.7762 16.2498 29.5V28.8333Z" />
      <path d="M16.2498 31.3333C16.2498 31.0572 16.4736 30.8333 16.7498 30.8333H19.0831C19.3592 30.8333 19.5831 31.0572 19.5831 31.3333V32C19.5831 32.2762 19.3592 32.5 19.0831 32.5H16.7498C16.4736 32.5 16.2498 32.2762 16.2498 32V31.3333Z" />
      <path d="M16.2498 33.8333C16.2498 33.5572 16.4736 33.3333 16.7498 33.3333H19.0831C19.3592 33.3333 19.5831 33.5572 19.5831 33.8333V34.5C19.5831 34.7762 19.3592 35 19.0831 35H16.7498C16.4736 35 16.2498 34.7762 16.2498 34.5V33.8333Z" />
      <path d="M20.4163 26.3333C20.4163 26.0572 20.6401 25.8333 20.9163 25.8333H23.2496C23.5257 25.8333 23.7496 26.0572 23.7496 26.3333V27C23.7496 27.2762 23.5257 27.5 23.2496 27.5H20.9163C20.6401 27.5 20.4163 27.2762 20.4163 27V26.3333Z" />
      <path d="M20.4163 28.8333C20.4163 28.5572 20.6401 28.3333 20.9163 28.3333H23.2496C23.5257 28.3333 23.7496 28.5572 23.7496 28.8333V29.5C23.7496 29.7762 23.5257 30 23.2496 30H20.9163C20.6401 30 20.4163 29.7762 20.4163 29.5V28.8333Z" />
      <path d="M20.4163 31.3333C20.4163 31.0572 20.6401 30.8333 20.9163 30.8333H23.2496C23.5257 30.8333 23.7496 31.0572 23.7496 31.3333V32C23.7496 32.2762 23.5257 32.5 23.2496 32.5H20.9163C20.6401 32.5 20.4163 32.2762 20.4163 32V31.3333Z" />
      <path d="M20.4163 33.8333C20.4163 33.5572 20.6401 33.3333 20.9163 33.3333H23.2496C23.5257 33.3333 23.7496 33.5572 23.7496 33.8333V34.5C23.7496 34.7762 23.5257 35 23.2496 35H20.9163C20.6401 35 20.4163 34.7762 20.4163 34.5V33.8333Z" />
      <path d="M24.583 26.3333C24.583 26.0572 24.8069 25.8333 25.083 25.8333H27.4163C27.6925 25.8333 27.9163 26.0572 27.9163 26.3333V27C27.9163 27.2762 27.6925 27.5 27.4163 27.5H25.083C24.8069 27.5 24.583 27.2762 24.583 27V26.3333Z" />
      <path d="M24.583 28.8333C24.583 28.5572 24.8069 28.3333 25.083 28.3333H27.4163C27.6925 28.3333 27.9163 28.5572 27.9163 28.8333V29.5C27.9163 29.7762 27.6925 30 27.4163 30H25.083C24.8069 30 24.583 29.7762 24.583 29.5V28.8333Z" />
      <path d="M24.583 31.3333C24.583 31.0572 24.8069 30.8333 25.083 30.8333H27.4163C27.6925 30.8333 27.9163 31.0572 27.9163 31.3333V34C27.9163 34.5523 27.4686 35 26.9163 35H25.083C24.8069 35 24.583 34.7762 24.583 34.5V31.3333Z" />
    </svg>
  );
};

export default PosQr;
